<script setup>
import { i18n } from 'boot/i18n';

import { FOCUS_AREAS, STRICTNESS_MODES } from '../../domain/constants/aiAuditorSettings';

defineOptions({ name: 'AuditSettingsForm' });

const props = defineProps({
  settings: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(['update:settings']);

/**
 * Emits an update to the focus areas in the settings.
 * @param {string[]} newFocusAreas - The new focus areas.
 */
function emitFocusAreas(newFocusAreas) {
  emit('update:settings', {
    ...props.settings,
    focusAreas: newFocusAreas,
  });
} // emitFocusAreas()

/**
 * Emits an update to the strictness in the settings.
 * @param {string} newStrictness - The new strictness mode.
 */
function emitStrictness(newStrictness) {
  emit('update:settings', {
    ...props.settings,
    strictness: newStrictness,
  });
} // emitStrictness()

const focusAreaOptions = FOCUS_AREAS.map((area) => ({
  value: area.value,
  label: i18n.t(area.labelKey),
}));

const strictnessOptions = STRICTNESS_MODES.map((mode) => ({
  value: mode.value,
  label: i18n.t(mode.labelKey),
}));

</script>
<template>
  <p class="text-subtitle2 col-12">
    {{ i18n.t('noteAuditor.auditSettingsForm.focusAreasHeading') }}
  </p>
  <q-option-group
    :model-value="props.settings.focusAreas"
    :options="focusAreaOptions"
    type="checkbox"
    @update:model-value="emitFocusAreas"
  />
  <div class="row col-12 q-my-md">
    <p class="text-subtitle2 col-12 q-mt-md">
      {{ i18n.t('noteAuditor.auditSettingsForm.strictnessModeHeading') }}
    </p>
    <q-btn-toggle
      :model-value="props.settings.strictness"
      :options="strictnessOptions"
      spread
      class="col-12"
      @update:model-value="emitStrictness"
    />
  </div>
</template>
